<script setup lang="ts">
import { toneChipStyle, type LayerTone } from "./layerTone";

defineProps<{
  rows: Array<{
    label: string;
    value: string;
    mono?: boolean;
    source: string;
    sourceTone: LayerTone;
  }>;
}>();
</script>

<template>
  <div class="space-y-2">
    <div class="text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
      Where each field comes from
    </div>

    <div class="overflow-hidden rounded-lg border bg-card">
      <div
        v-for="row in rows"
        :key="`${row.label}-${row.source}`"
        class="grid grid-cols-[92px_minmax(0,1fr)_auto] items-center gap-2 border-b px-3 py-2 last:border-b-0"
      >
        <div class="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          {{ row.label }}
        </div>
        <code
          v-if="row.mono"
          class="truncate rounded bg-secondary px-1.5 py-0.5 font-mono text-[10.5px] text-secondary-foreground"
        >
          {{ row.value }}
        </code>
        <div v-else class="truncate text-[11.5px] text-foreground">{{ row.value }}</div>
        <span
          class="inline-flex shrink-0 rounded-full border px-1.5 py-0.5 text-[9.5px] font-semibold"
          :style="toneChipStyle(row.sourceTone)"
        >
          {{ row.source }}
        </span>
      </div>
    </div>
  </div>
</template>
